module.exports = __webpack_public_path__ + "static/media/DropDown.3c519935.svg";